import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import DonationModal from "./Donationmodal";
import { Link } from "react-router-dom";
const HomeBanner = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="home-banner-container ">
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        modules={[Autoplay, Pagination]}
        className="mySwiper home-banner-swiper m-0 w-100"
      >
        <SwiperSlide>
          <div className="slide-inner-wrapper">
            <div className="container  d-flex align-items-center position-relative z-2">
              <div className="row w-100 align-items-center">
                {/* LEFT CONTENT */}
                <div className="col-12 col-lg-6">
                  <div className="text-start banner-text-block">
                    <h1 className="main-heading">
                      <span className="heading-part-1">One Donation</span>{" "}
                      <br />
                      <span className="heading-part-2">Is Recycled</span> <br />
                      <span className="heading-part-2">Many Times</span>
                    </h1>

                    <div className="d-flex flex-wrap gap-3 mt-3">
                      <button
                        className="donate-button"
                        onClick={() => setShowModal(true)}
                      >
                        Donate Now
                        <span className="arrow-icon">
                          <img src="../images/arrowicon.png" alt="arrow" />
                        </span>
                      </button>

                      <Link to="./CSP">
                        <button className="donate-button">
                          Partner
                          <span className="arrow-icon">
                            <img src="../images/arrowicon.png" alt="arrow" />
                          </span>
                        </button>
                      </Link>

                      <Link to="./Entrepreneur">
                        <button className="donate-button">
                          Borrow
                          <span className="arrow-icon">
                            <img src="../images/arrowicon.png" alt="arrow" />
                          </span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className="col-12 col-lg-6 d-flex justify-content-center mt-4 mt-lg-0">
                  <img
                    src="../images/banner (2).png"
                    alt="Banner Visual"
                    className=" w-75 banner-right-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* ✅ Modal render here */}
      <DonationModal
        show={showModal}
        onClose={() => setShowModal(false)}
        // ✅ prop ka naam yeh hi rakho
      />
    </div>
  );
};

export default HomeBanner;
